import { useQuery } from '@tanstack/react-query'
import { orderApi, type OrderSendHistoryItem } from '../api/orderApi'

// 자재 세부 내역 팝업(B-11)용 발송·회신 이력(A9). 팝업이 열려 있을 때만 조회한다.

export const ORDER_SENDS_KEY = 'order-sends'

export function useOrderSends(orderVendorId: number | null, enabled: boolean) {
  return useQuery<OrderSendHistoryItem[]>({
    queryKey: [ORDER_SENDS_KEY, orderVendorId],
    queryFn: ({ signal }) => orderApi.getOrderSends(orderVendorId as number, signal),
    enabled: enabled && orderVendorId != null,
    staleTime: 0,
    retry: false,
  })
}
